import React from 'react';
import { ethers } from 'ethers';
import PackageRow from './PackageRow';
import { DEFAULT_PACKAGE_PRICES } from '../../utils/constants';

const PackageList = ({ user, onChanged }) => {
  const prices = (user.packagePrices && user.packagePrices.length === 7)
    ? user.packagePrices
    : DEFAULT_PACKAGE_PRICES.map((p) => ethers.utils.parseUnits(String(p), 18));

  return (
    <div className="tier-list">
      {prices.map((p, i) => {
        const status = user.packageStatuses?.[i];
        const prevActive = i === 0 ? true : !!user.packageStatuses?.[i - 1]?.isActive;
        return (
          <PackageRow
            key={i}
            index={i}
            price={p}
            status={status}
            registered={user.registered}
            prevActive={prevActive}
            onChanged={onChanged}
            isLast={i === prices.length - 1}
          />
        );
      })}
    </div>
  );
};

export default PackageList;
